export default __webpack_public_path__ + "static/media/mach_payment.65d29708.png";